var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGatsby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5884 0C9.54198 0 0.588379 8.9536 0.588379 20C0.588379 31.0464 9.54198 40 20.5884 40C31.6348 40 40.5884 31.0464 40.5884 20C40.5884 8.9536 31.6348 0 20.5884 0ZM4.88598 20.208L20.3804 35.7024C11.8716 35.592 4.99638 28.7168 4.88598 20.208ZM24.1036 35.3104L5.27798 16.4848C6.87478 9.504 13.1228 4.2944 20.5884 4.2944C25.806 4.2944 30.43 6.84 33.286 10.7568L31.1116 12.6752C28.7948 9.3536 24.9452 7.1792 20.5884 7.1792C15.0412 7.1792 10.3164 10.7024 8.53078 15.6336L24.9548 32.056C28.9436 30.6112 32.0108 27.2448 33.038 23.0752H26.2316V20H36.2956C36.294 27.4656 31.0844 33.7136 24.1036 35.3104Z",
    fill: "#744C9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.588379)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatsby);
export default __webpack_public_path__ + "static/media/gatsby.42d06cc83b411a018ecd84e3048f3a42.svg";
export { ForwardRef as ReactComponent };